import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'
import { EModalState } from './constants'

import { ExposePrivateKeyFormWrapper } from './expose-private-key-form-wrapper.component'
import { PrivateKeyCard } from './private-key-card.component'
import { RequestPrivateKeyForm } from './request-private-key-form.component'

interface IProps {
  verifyFn: PrivateKeyVerifyFn
  requestFn: PrivateKeyRequestFn
}

const ExposePrivateKey = ({ verifyFn, requestFn }: IProps) => {
  const { mutateAsync: verifyPkRequest, data: wallet } = verifyFn()
  const [searchParams, setSearchParams] = useSearchParams()
  const { mutateAsync: requestPrivateKey, isLoading: isRequesting } = requestFn()

  const pkVerificationOpen = searchParams.get('pk_verification_open')
  const [modalView, setModalView] = useState(
    wallet
      ? EModalState.Wallet
      : pkVerificationOpen
        ? EModalState.Verification
        : EModalState.Request,
  )

  const handleExposePrivateKey = async (code: string) => {
    const resp = await verifyPkRequest(code)

    setSearchParams((prev) => {
      prev.delete('pk_verification_open')
      prev.delete('pk_code')
      return prev
    })

    resp ? setModalView(EModalState.Wallet) : setModalView(EModalState.Request)
  }

  const handleRequestPrivateKey = async () => {
    const resp = await requestPrivateKey()
    if (!resp) return

    setSearchParams((prev) => {
      prev.set('pk_verification_open', 'true')
      return prev
    })

    setModalView(EModalState.Verification)
  }

  return (
    <>
      {modalView === EModalState.Request && (
        <RequestPrivateKeyForm
          changeModalState={setModalView}
          isRequesting={isRequesting}
          requestPrivateKey={handleRequestPrivateKey}
        />
      )}
      {modalView === EModalState.Verification && (
        <ExposePrivateKeyFormWrapper
          changeModalState={setModalView}
          exposePrivateKey={handleExposePrivateKey}
        />
      )}
      {modalView === EModalState.Wallet && <PrivateKeyCard wallet={wallet!} />}
    </>
  )
}

export { ExposePrivateKey }
